import React from "react";

const YourActivityItem = ({ title, desc, date }) => {
  return (
    <div className="youractivity-item-container">
      <div className="youractivity-item-details-container">
        <h5 className="youractivity-item-primary-text">{title}</h5>
        <p className="youractivity-item-secondary-text">{desc}</p>
      </div>
      <div className="youractivity-item-date">
        {new Date(date)?.toDateString()?.slice(4)}
      </div>
    </div>
  );
};

export default YourActivityItem;
